/* Greeting Card Add-on for Minimog
 * --------------------------------
 * 1) Product page: dropdown se card select -> image preview; Add to Cart par
 *    main product + card dono ek hi request me alag line items ban ke add.
 *    Rolex Original Box bhi isi tarah bundle hota hai agar checked ho.
 * 2) Cart drawer / Cart page: har product ke neeche optional "Add a Greeting
 *    Card" option. Select + Add karne par card cart me add hota hai aur drawer
 *    + cart page khud refresh ho jate hain. Card already cart me ho to option
 *    chhup jata hai.
 *
 * Sab theme ke apne add-to-cart flow / pub-sub events use karta hai.
 */
(function () {
  'use strict';

  // Double-load guard (snippet do jagah se include ho sakta hai)
  if (window.__gcAddonLoaded) return;
  window.__gcAddonLoaded = true;

  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function uniq(arr) {
    return arr.filter(function (v, i) { return arr.indexOf(v) === i; });
  }
  function notify(message, type) {
    try {
      var T = window.MinimogTheme;
      if (T && T.Notification && T.Notification.show) {
        T.Notification.show({ target: document.body, method: 'appendChild', type: type || 'warning', message: message, last: 3000, sticky: false });
        return;
      }
    } catch (e) {}
    if (type === 'error' || type === 'warning') console.warn('[GC]', message);
  }
  function emitCartUpdate() {
    try {
      var T = window.MinimogTheme;
      var ev = (T && T.pubSubEvents && T.pubSubEvents.cartUpdate) || 'cart-update';
      if (window.MinimogEvents && window.MinimogEvents.emit) {
        window.MinimogEvents.emit(ev, { source: 'gc-cart-addon' });
      }
    } catch (e) {}
  }

  /* ===================== UI (event delegation) ===================== */

  // Product-page add-on preview + toggle
  function handleProductChange(target) {
    var addon = target.closest('[data-gc-addon]');
    if (!addon) return;

    if (target.matches('[data-gc-toggle]')) {
      var body = addon.querySelector('[data-gc-body]');
      if (body) body.hidden = !target.checked;
      if (!target.checked) clearPreview(addon, '[data-gc-preview]', '[data-gc-img]', '[data-gc-caption]', '[data-gc-select]');
      return;
    }
    if (target.matches('[data-gc-select]')) {
      updatePreview(addon, target, '[data-gc-preview]', '[data-gc-img]', '[data-gc-caption]');
    }
  }

  // Cart add-on preview + toggle
  function handleCartChange(target) {
    var addon = target.closest('[data-gc-cart-addon]');
    if (!addon) return;

    if (target.matches('[data-gc-cart-toggle]')) {
      var body = addon.querySelector('[data-gc-cart-body]');
      if (body) body.hidden = !target.checked;
      if (!target.checked) clearPreview(addon, '[data-gc-cart-preview]', '[data-gc-cart-img]', '[data-gc-cart-caption]', '[data-gc-cart-select]');
      return;
    }
    if (target.matches('[data-gc-cart-select]')) {
      updatePreview(addon, target, '[data-gc-cart-preview]', '[data-gc-cart-img]', '[data-gc-cart-caption]');
      var addBtn = addon.querySelector('[data-gc-cart-add]');
      if (addBtn) addBtn.disabled = !target.value;
    }
  }

  function updatePreview(addon, select, previewSel, imgSel, capSel) {
    var preview = addon.querySelector(previewSel);
    var img = addon.querySelector(imgSel);
    var cap = addon.querySelector(capSel);
    var opt = select.options[select.selectedIndex];
    var src = opt ? opt.getAttribute('data-image') : '';
    if (select.value && src) {
      if (img) { img.src = src; img.alt = opt.textContent.trim(); }
      if (cap) cap.textContent = opt.textContent.trim();
      if (preview) preview.hidden = false;
    } else {
      clearPreview(addon, previewSel, imgSel, capSel);
    }
  }
  function clearPreview(addon, previewSel, imgSel, capSel, selectSel) {
    var preview = addon.querySelector(previewSel);
    var img = addon.querySelector(imgSel);
    var cap = addon.querySelector(capSel);
    if (preview) preview.hidden = true;
    if (img) { img.src = ''; img.alt = ''; }
    if (cap) cap.textContent = '';
    if (selectSel) { var s = addon.querySelector(selectSel); if (s) s.value = ''; }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-gc-addon]')) handleProductChange(t);
    else if (t.closest('[data-gc-cart-addon]')) handleCartChange(t);
  });

  /* ===================== Cart-context add ===================== */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gc-cart-add]');
    if (!btn) return;
    e.preventDefault();

    var addon = btn.closest('[data-gc-cart-addon]');
    var select = addon && addon.querySelector('[data-gc-cart-select]');
    if (!select || !select.value) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    var drawer = document.querySelector('m-cart-drawer');
    var sectionIds = drawer ? uniq(drawer.getSectionsToRender().map(function (s) { return s.id; })) : [];

    var body = { items: [{ id: select.value, quantity: 1 }] };
    if (sectionIds.length) { body.sections = sectionIds; body.sections_url = window.location.pathname; }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          notify(res.description || res.message || 'Could not add the card.', 'warning');
          return;
        }
        // Drawer ko theme ke apne API se refresh karo
        if (drawer && res.sections) {
          try { drawer.renderContents(res); } catch (err) {}
        }
        // Cart page + count bubble refresh
        emitCartUpdate();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        notify('Network error while adding the card.', 'warning');
      });
  });

  /* ===================== Product form: bundle extras on submit ===================== */

  // Greeting card selection (agar product page par addon ho aur checked + select value ho)
  function getSelectedCard(form) {
    var addon = form.querySelector('[data-gc-addon]');
    if (!addon) return null;
    var toggle = addon.querySelector('[data-gc-toggle]');
    var select = addon.querySelector('[data-gc-select]');
    if (toggle && !toggle.checked) return null;
    if (!select || !select.value) return null;
    return { id: select.value, qty: 1 };
  }

  // Rolex Original Box selection (product page context, checkbox checked ho to)
  function getSelectedBox(form) {
    var addon = form.querySelector('[data-rolex-addon][data-context="product"]');
    if (!addon) return null;
    var toggle = addon.querySelector('[data-rolex-toggle]');
    if (!toggle || !toggle.checked) return null;
    var variantId = addon.getAttribute('data-box-variant-id');
    if (!variantId) return null;
    return { id: variantId, qty: 1 };
  }

  // Saare selected add-ons (card, box, future add-ons yahan add kiye ja sakte hain)
  function getSelectedExtras(form) {
    var extras = [];
    var card = getSelectedCard(form);
    if (card) extras.push(card);
    var box = getSelectedBox(form);
    if (box) extras.push(box);
    return extras;
  }

  function isActive(el) {
    if (el.disabled) return false;
    var t = (el.type || '').toLowerCase();
    if (t === 'checkbox' || t === 'radio') return el.checked;
    return true;
  }
  function bundledName(name) {
    if (name === 'id') return 'items[0][id]';
    if (name === 'quantity') return 'items[0][quantity]';
    if (name === 'selling_plan') return 'items[0][selling_plan]';
    var m = name.match(/^properties\[(.*)\]$/);
    if (m) return 'items[0][properties][' + m[1] + ']';
    return null;
  }
  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = name;
    i.value = value == null ? '' : value;
    i.setAttribute('data-gc-injected', '');
    return i;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM_SELECTOR)) return;

    var extras = getSelectedExtras(form);
    if (!extras.length) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || idInput.disabled || !idInput.value) return;

    var injected = [];
    var disabledOriginals = [];
    var qtySeen = false;

    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.hasAttribute('data-gc-injected')) return;
      if (!isActive(el)) return;
      var mapped = bundledName(el.name);
      if (!mapped) return;
      if (el.name === 'quantity') qtySeen = true;
      var node = hidden(mapped, el.value);
      injected.push(node);
      form.appendChild(node);
      el.disabled = true;
      disabledOriginals.push(el);
    });

    if (!qtySeen) {
      var q = hidden('items[0][quantity]', '1');
      injected.push(q);
      form.appendChild(q);
    }

    // Har selected extra (card, box, ...) ko sequential index par bundle karo
    extras.forEach(function (extra, idx) {
      var n = idx + 1;
      var i1 = hidden('items[' + n + '][id]', extra.id);
      var i2 = hidden('items[' + n + '][quantity]', String(extra.qty));
      injected.push(i1, i2);
      form.appendChild(i1);
      form.appendChild(i2);
    });

    setTimeout(function () {
      injected.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      disabledOriginals.forEach(function (el) { el.disabled = false; });
    }, 0);
  }, true); // capture: theme ke submit handler se pehle

})();
